import { render, staticRenderFns } from "./AddOrUpdate.vue?vue&type=template&id=caf98ea0&scoped=true"
import script from "./AddOrUpdate.vue?vue&type=script&lang=js"
export * from "./AddOrUpdate.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdate.vue?vue&type=style&index=0&id=caf98ea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf98ea0",
  null
  
)

export default component.exports